/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 19/10/2022
 */
import {DataFilter} from "@qwoach/firebase-data-manager";
import FilterOptions from "@/core/js/backend/filters/FilterOptions.js";

export default class BaseDataFilter extends DataFilter {


	constructor(limit = 10) {
		super(limit)
		// test
		// this.filterOptions = new FilterOptions()
	}

	merge(otherFilter){
		return super.merge(otherFilter)
	}
	mergeIf(otherFilter, condition){
		return super.mergeIf(otherFilter, condition)
	}


	where(field, operation, value){
		return super.where(field, operation, value)
	}
	whereIf(field, operation, value, condition){
		return super.whereIf(field, operation, value, condition)
	}
	// whereIf(field, operation, value, condition){
	// 	return super.where(field, operation, value, condition)
	// }

	orderByAsc(field){
		return super.orderByAsc(field)
	}

	addTextSearchFilterOption(field, valueArray, valueMaxLength = 5, toLowerCase = true){
		let shouldTrim = valueMaxLength && valueMaxLength > 1

		valueArray = valueArray.map(value => {
			if(toLowerCase){
				value = value.toLowerCase()
			}
			if(shouldTrim) {
				value = value.substring(0, valueMaxLength)
			}
			return value
		})
		valueArray = valueArray.filter(val => !!val)
		let hasData = valueArray.length > 0

		if(hasData){
			// 'object-contains-all' and 'object-contains-any' are custom commands not supported by Firestore
			// what they do internally is they create a list of 'where' clauses grouped by AND or OR respectively
			// like this: where(${field}.${valueArray[i]}, "==", true)
			this.filterOptions.add(field, "object-contains-all", valueArray)
		}
		return this;
	}

	orderByDesc(field){
		return super.orderByDesc(field)
	}

	setLimit(limit){
		return super.setLimit(limit)
	}

	reset(){
		return super.reset()
	}

	isEmpty(){
		return super.isEmpty()
	}
	hasFilterOptions(){
		return super.hasFilterOptions()
	}
	hasSortOptions(){
		return super.hasSortOptions()
	}

	whereFilter(filterItem){
		return super.whereFilter(filterItem)
	}
	whereFilterIf(filterItem, condition){
		return super.whereFilterIf(filterItem, condition)
	}

	hasFilterByFieldName(fieldName){
		return super.hasFilterByFieldName(fieldName)
	}

	hasSortByFieldName(fieldName){
		return super.hasSortByFieldName(fieldName)
	}


	orStart(){
		return super.orStart()
	}
	andStart(){
		return super.andStart()
	}
	orEnd(){
		return super.orEnd()
	}
	andEnd(){
		return super.andEnd()
	}


}
